import { ethers as r } from "ethers";
import { StakingPoolsContractAbi as n } from "@deorderbook/contracts/abi";
import { StakingPoolsAddress as e } from "@deorderbook/contracts";
import { signer as i, provider as s } from "./provider.mjs";
const c = () => new r.Contract(
  e,
  n
), g = (t = !1) => {
  const o = c();
  return t ? o.connect(i) : o.connect(s);
};
export {
  c as initStakingPoolContract,
  g as useStakingPoolContract
};
//# sourceMappingURL=stakingPoolContract.mjs.map
